import { ClientDetailsContent, ClientDetailsWrapper } from './styles'
import Template from 'pages/components/Template'
import { useParams } from 'react-router-dom'
import Header from 'components/Header'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client'
import { DOMICILIATION, DomiciliationResult, DomiciliationVariables } from 'pages/ClientDetails/queries'
import { Maybe } from 'monet'
import ClientContent from 'pages/ClientDetails/components/ClientContent'
import { displayErrors } from 'globals/graphql'

interface Params {
  clientId: string
  quickAction?: string
}

const ClientDetails = () => {
  const { clientId } = useParams<Params>()
  const { t } = useTranslation()

  const { data } = useQuery<DomiciliationResult, DomiciliationVariables>(DOMICILIATION, {
    variables: { domiciliationId: Number(clientId) },
    ...displayErrors
  })

  return (
    <Template activeMenu='/clients' noPadding noScroll={false}>
      {(currentUser, currentCenters) => (
        <ClientDetailsWrapper>
          {Maybe.fromFalsy(data)
            .flatMap((data) => Maybe.fromFalsy(data.domiciliation))
            .map((dom) => (
              <>
                <ClientDetailsContent>
                  <Header
                    title={t('clients.title')}
                    backlink={'/clients'}
                    currentUser={currentUser}
                    currentCenters={currentCenters}
                  />

                  <ClientContent domiciliation={dom} />
                </ClientDetailsContent>
              </>
            ))
            .getOrElse(<></>)}
        </ClientDetailsWrapper>
      )}
    </Template>
  )
}

export default ClientDetails
